import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useSolutionsProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';

const SolutionsDetailsList = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant: { detailsList  } ,  } = useSolutionsProductData();
    const title = getLabel('products.solutions.header.details');
    if (detailsList.length === 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        "data-t": "solutions-details-list",
        variant: "subheading1"
    }, title), /*#__PURE__*/ React.createElement("ul", null, detailsList.map((detail)=>/*#__PURE__*/ React.createElement("li", {
            key: detail
        }, detail)
    )));
};

export { SolutionsDetailsList };
//# sourceMappingURL=SolutionsDetailsList.js.map
